import {ModalBody, ModalFooter, Alert} from "reactstrap";
import React, { useEffect } from 'react';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useTranslation } from 'react-i18next';
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import {loginGuestUser} from "../../slices/auth/login/thunk";
import {createDTO} from "../../helpers/DtoHelper";
import {validators} from "../../helpers/ValidatorHelper";
import {loginGuestReset} from "../../slices/auth/profile/reducer";
import {WelcomeAlert} from "../WelcomeAlert";


export const RegisterGuestForm = ({isModalRegisterAndVoteOpen, eventId}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const selectEventSongVote = createSelector(
    (state) => state.Profile,
    (slice) => ({
      loginGuestError: slice.loginGuestError,
      loginGuestViolations: slice.loginGuestViolations,
    })
  );
  const {
    loginGuestError,
    loginGuestViolations,
  } = useSelector(selectEventSongVote);

  useEffect(() => {
    if (loginGuestViolations?.length > 0 && isModalRegisterAndVoteOpen) {
      if (Array.isArray(loginGuestViolations)) {
        loginGuestViolations.forEach((violation) => {
          registerGuestForm.setFieldError(violation.propertyPath, t(violation.message));
        });
      } else {
        registerGuestForm.setStatus(t(loginGuestViolations))
      }
    }
    dispatch(loginGuestReset());
  }, [loginGuestError]);

  const registerGuestForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: '',
      eventId: eventId,
    },
    validationSchema: Yup.object({
      username: validators.username(t)
    }),
    onSubmit: async (values) => {
      dispatch(loginGuestUser(createDTO('userRegisterApi', values)));
    }
  });


  return (
      <form className="tablelist-form" onSubmit={(e) => {
        e.preventDefault();
        registerGuestForm.handleSubmit();
      }}>
        <ModalBody>
          <WelcomeAlert/>
          {registerGuestForm.status &&
            <div className="alert alert-danger" role="alert">
              <strong>{t(registerGuestForm.status)}</strong>
            </div>
          }
            <div className="mb-3">
              {/*<label htmlFor="username-field" className="form-label">{t('Name or nick')}</label>*/}
              <input
                id="username" name="username"
                className={`form-control form-control-lg ${registerGuestForm.touched.username && registerGuestForm.errors.username ? 'is-invalid' : ''}`}
                type="text" placeholder={t("Your name or nick")}
                onChange={registerGuestForm.handleChange}
                onBlur={registerGuestForm.handleBlur}
                value={registerGuestForm.values.username}/>
              {registerGuestForm.touched.username && registerGuestForm.errors.username && (
                <div className="invalid-feedback">{registerGuestForm.errors.username}</div>
              )}
            </div>
          <input readOnly="readOnly" id="eventId" name="eventId" className="d-none" value={registerGuestForm.values.eventId}/>

        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            <button type="submit" className="btn bg-transparent border-0 shadow-none color-primary d-inline-flex align-items-center px-2" id="add-btn">
              <i className="ri-check-double-line align-middle me-2" style={{ fontSize: '1.6rem' }}></i>{t('Join us')}!
            </button>
          </div>
        </ModalFooter>
      </form>
  );
}
